module.exports = __webpack_public_path__ + "6e50785fef51b0b2f4de0f700c94f29b.png";